import cn from 'classnames';

import { IConDefaultType } from '../types';

function HistoryChatBubbleIcon({ color, className, size = 16, rotate, flip }: IConDefaultType) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="comment">
          <path
            id="Vector"
            d="M6.74359 1.5H9.61538C12.7875 1.5 15.359 4.07149 15.359 7.24359C15.359 10.4157 12.7875 12.9872 9.61538 12.9872V15.5C6.02564 14.0641 1 11.9103 1 7.24359C1 4.07149 3.57149 1.5 6.74359 1.5Z"
            fill={color || '#ADB0B8'}
          />
        </g>
      </svg>
    </i>
  );
}

export default HistoryChatBubbleIcon;
